<!-- feature large screen -->
<mat-card
    style="padding: 0px; min-width: 100%"
    [ngClass]="
        this.industry.ProductID == 'MW'
            ? this.toggleSelected || this.feature.isChecked
                ? 'MWSelectedFeature'
                : 'noSelectedFeature'
            : this.toggleSelected || this.feature.isChecked
            ? 'MCSelectedFeature'
            : 'noSelectedFeature'
    "
>
    <mat-card-content style="margin: 0; min-width: 100%">
        <div [ngClass]="this.smallScreen ? 'flex-columns' : 'flex-row'">
            <div
                [class]="getCorrectSelectionArea(this.industry.ProductID)"
                *ngIf="setCorrectVisibility(this.industry.ProductID, this.feature.Options)"
            >
                <div [ngSwitch]="getAvailability()">
                    <div *ngIf="isNotAlways()">
                        <div *ngSwitchDefault>
                            <div style="margin-right: 0px; width: 100%">
                                <mat-slide-toggle
                                    [checked]="feature.isChecked || feature.IsMandatory"
                                    [disabled]="feature.IsMandatory"
                                    (change)="onToggleChange(feature)"
                                ></mat-slide-toggle>
                            </div>
                        </div>
                        <div *ngSwitchCase="'optional'">
                            <div style="margin-right: 0px; width: 100%">
                                <mat-slide-toggle
                                    [checked]="feature.isChecked || feature.IsMandatory"
                                    [disabled]="feature.IsMandatory"
                                    (change)="onToggleChange(feature)"
                                ></mat-slide-toggle>
                            </div>
                        </div>
                        <div *ngSwitchCase="'standalone'">
                            <div style="margin-right: 0px; width: 100%">
                                <mat-slide-toggle
                                    [checked]="feature.isChecked || feature.IsMandatory"
                                    [disabled]="feature.IsMandatory"
                                    (change)="onToggleChange(feature)"
                                ></mat-slide-toggle>
                            </div>
                        </div>
                        <div *ngSwitchCase="'count'">
                            <div style="display: flex; justify-content: flex-end; width: 100%">
                                <div style="margin-top: 0.2rem; margin-right: 0.1rem">
                                    <div class="wrapperNrUsersClass-small">
                                        <button class="plusminus-small" (click)="handleOptionMinus()">-</button>
                                        <input
                                            [(ngModel)]="feature.CurrNrOfUser"
                                            [disabled]="feature.IsMandatory"
                                            [checked]="feature.isChecked || feature.IsMandatory"
                                            min="0"
                                            readonly
                                            class="num-small"
                                            onkeydown="return false"
                                        />
                                        <button class="plusminus-small" (click)="handleOptionPlus()">+</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngSwitchCase="'ppt'">
                            <mat-slide-toggle
                                [checked]="feature.isChecked || feature.IsMandatory"
                                [disabled]="feature.IsMandatory"
                                (change)="onToggleChange(feature)"
                            ></mat-slide-toggle>
                            <label class="error">{{ errorMessage }}</label>
                        </div>
                    </div>
                </div>
            </div>

            <div [ngClass]="this.smallScreen ? 'verticalTitleDivStyle' : 'horizontalTitleDivStyle'">
                <div
                    style="
                        display: flex;
                        flex-direction: column;
                        align-items: start;
                        margin: 0px;
                        padding: 0px;
                        margin-bottom: 0.5rem;
                        margin-top: 0.5rem;
                        margin-left: 0.8rem;
                        flex-grow: 8;
                    "
                >
                    <div class="cardFeatureTitleContainer" [ngClass]="this.smallScreen ? 'flex-columns' : 'flex-row'">
                        <div>
                            <span class="cardFeatureTitle" translate>{{ this.featureDescription }}</span>
                        </div>
                        <div style="padding-top: 0.3rem">
                            <mat-chip-list aria-label="" disabled="true">
                                <mat-chip class="bgBluMagoLight" *ngIf="isPlanned(this.feature.Status)" selected>
                                    <span class="text-chip" translate>planned</span>
                                </mat-chip>
                                <mat-chip class="phaseoutChip" *ngIf="isPhaseOut(this.feature.Status)" selected>
                                    <span class="text-chip" translate>phaseout</span>
                                </mat-chip>
                            </mat-chip-list>
                        </div>
                    </div>

                    <div style="margin: 0px; padding: 0px">
                        <span class="text-italic small">{{
                            getCorrectPhraseVsStatus(feature.Status, feature.ReleaseFrom, feature.ReleaseTo)
                        }}</span>
                    </div>
                    <div style="margin: 0px; padding: 0px">
                        <span class="text-smaller">{{ this.featureDataSheet }}</span>
                    </div>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>
